import { useEffect, useState } from 'preact/hooks';

/** 发码倒计时（秒）。start(n) 重新起跑，归零自停。 */
export function useCountdown(): { seconds: number; start: (n: number) => void } {
  const [seconds, setSeconds] = useState(0);
  useEffect(() => {
    if (seconds <= 0) return;
    const timer = setTimeout(() => setSeconds(seconds - 1), 1000);
    return () => clearTimeout(timer);
  }, [seconds]);
  return { seconds, start: setSeconds };
}
